import {css} from 'emotion'
import { Colors, SubtitlePage, Link , CardSmall} from './..'

export const TeamStyle = (userReady) => css({
  '.team-filter': {
    margin: '0 2rem',
  },
  '.teams-inner': {
    maxWidth: 1400,
    margin: '4rem auto',
    opacity: userReady ? 1 : 0,
    transform: `translateY(${ userReady ? 0 : 10}px)`,
    transition: `all ${userReady ? 400 : 200}ms ease`,
    'h2': {
      textAlign: 'center',
      ...SubtitlePage,
    },
   },
   'h3': {
    fontSize: '1.125rem',
   },
  '.team': {
    maxWidth: '50%',
    flexBasis: '50%',
    margin: '1rem 0',
    '&:nth-child(even)':{
      paddingLeft: '0.5rem',
    },
    '&:nth-child(odd)':{
      paddingRight: '0.5rem',
    },
    '@media (min-width: 1024px)': {
      maxWidth: '50%',
      flexBasis: '50%',
      margin: '2rem 0',
      '&:nth-child(even)':{
        paddingLeft: '2rem',
      },
      '&:nth-child(odd)':{
        paddingRight: '2rem',
      },
    }
  }
})

export const TeamCardStyle = (cover, active) => css({
  '.team': {
    '&-picture': {
      background: `black url(${cover}) no-repeat center`,
      backgroundSize: 'cover',
      maxWidth: '100%',
      flexBasis: '100%',
      height: 240,
      '@media (min-width: 1024px)': {
        maxWidth: 'calc(1/3 * 100%)',
        flexBasis: 'calc(1/3 * 100%)',
      }
    },
    '&-inner': {
      position: 'relative',
      background: 'white',
      boxShadow: `0 0 20px 0 ${Colors.shadow}`,
      '@media (min-width: 1024px)': {
        height: 240,
      }
    },
    '&-verso': {
      background: 'black',
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      display: active ? 'block' : 'none',
      color: 'white',
      zIndex: 2,
      padding: '1rem',
      '@media (min-width: 1024px)': {
        paddingTop: '2rem',
        paddingRight: 'calc(1rem + 40px)',
        paddingBottom: '2rem',
        paddingLeft: '2rem',
      }
    },
    '&-information': {
      position: 'relative',
      padding: '1rem',
      maxWidth: '100%',
      flexBasis: '100%',
      '@media (min-width: 1024px)': {
        maxWidth: 'calc(2/3 * 100%)',
        flexBasis: 'calc(2/3 * 100%)',
        padding: '2rem',
      }
    },
    '&-link': {
      ...Link,
      color: Colors.grey,
      '@media (min-width: 1024px)': {
        bottom: '2rem',
        left: '2rem',
        position: 'absolute',
        cursor: 'pointer',
      }
    },
    '&-job, &-name': {
      textTransform: 'uppercase',
    },
    '&-name': {
      margin: 0,
    },
    '&-job': {
      ...CardSmall,
      fontSize: '1rem',
      marginBottom: '1rem',
    },
    '&-description, &-description p': {
      ...CardSmall,
      fontSize: '1rem',
      lineHeight: 1.4,
    },
    '&-close': {
      position: 'absolute',
      top: '1rem',
      right: '1rem',
      width: 12,
      height: 12,
      cursor: 'pointer',
      '@media (min-width: 1024px)': {
        width: 20,
        height: 20,
      },
      '&:after, &:before': {
        content: '""', 
        position: 'absolute',
        width: '100%',
        height: 2,
        background: 'white',
        top: '50%',
        left: 0,
        transformOrigin: 'center center',
        zIndex: 3,
      },
      '&:after': {
        transform: 'rotate(45deg)',
      },
      '&:before': {
        transform: 'rotate(-45deg)',
      }
    }
  }
})


// WEBPACK FOOTER //
// ./src/styles/containers/team.js